import * as yup from 'yup'

export class MichiganSOSBundleTitleApplicationDeliveryPhotoDto {
  titleApplicationDeliveryPhotoFileName?: string = undefined
  titleApplicationDeliveryPhotoFile?: File = undefined
}

export const michiganSOSBundleTitleApplicationDeliveryPhotoValidationSchema = yup.object({
  titleApplicationDeliveryPhotoFile: yup.mixed().required('Title Application Delivery Photo is required.')
})
